module.exports={select:"Seleccionar",selected:"Seleccionado"};